import { Divider } from 'antd'
import { FC } from 'react'

import { CumulativePerformance } from '../'
import { EmptyResult, Spinner } from '../../../../components'
import { PerformanceChart } from './Chart/Chart'
import Styles from './Performance.module.scss'
import { useTranslation } from 'react-i18next'

interface Props {
    cumulativePerf?: performanceRequest
}
export const Performance: FC<Props> = ({ cumulativePerf }) => {
    const { t } = useTranslation()
    return (
        <div className={Styles.container}>
            {!cumulativePerf?.data &&
            cumulativePerf?.validation?.status_code !== '0001' ? (
                <Spinner />
            ) : cumulativePerf &&
              cumulativePerf.data &&
              cumulativePerf.validation?.status_code === '0000' ? (
                <>
                    <CumulativePerformance
                        cumulativePerf={cumulativePerf.data}
                    />
                    <Divider />
                    <PerformanceChart />
                </>
            ) : (
                <EmptyResult description={t('txt_performance_des')} />
            )}
        </div>
    )
}
